import React from 'react'

export const MaintenanceNote = ({
  message,
  className,
}: {
  message: string
  className?: string
}): JSX.Element | null => {
  return <div className={'alert alert-warning maitenance-note ' + (className || '')}>{message}</div>
}
